<template>
  <div id="editar-tipo-medida" class="cria-dicas">
    <h1 class="title text-uppercase font-weight-bold">Editar Medida</h1>
    <hr class="linha-amarela" />
    <div class="form-group" v-if="tipoMedida[0].nome !== null">
      <label for="nome">Nome</label>
      <input
        type="text"
        class="form-control"
        id="nome"
        v-model="tipoMedida[0].nome"
      />
    </div>
    <div class="form-group" v-if="tipoMedida[0].descricao !== null">
      <label for="nome">Descrição</label>
      <input
        type="text"
        class="form-control"
        id="descricao"
        v-model="tipoMedida[0].descricao"
      />
    </div>
    <div class="form-group">
      <div class="btn btn-success" @click="editMeasuresType()">Editar</div>
      <div class="btn btn-voltar-dicas" @click="backList()">Voltar</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'editar-tipo-medida',
  mixins: [makeToast],
  props: ['id'],
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      tipoMedida: (state) => state.tipoMedida,
    }),
  },
  created() {
    this.$store.dispatch('showTipoMedida', this.id);
  },
  activated() {
    this.$store.dispatch('showTipoMedida', this.id);
  },
  methods: {
    editMeasuresType() {
      this.$store
        .dispatch('updateTipoMedidas', this.tipoMedida)
        .then(() => {
          if (this.getTipoNotification === 1) {
            this.makeToast('Sucesso!', this.getNotification, 'success');
            this.$router.push({ name: 'administrador-lista-medidas' });
          } else if (this.getTipoNotification === 3) {
            this.makeToast('Oopss!', this.getNotification, 'danger');
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          });
        });
    },
    backList() {
      this.$router.push({
        name: 'administrador-lista-medidas',
      });
    },
  },
};
</script>

<style>
@import '../../custom/css/cria-dicas.css';
</style>
